import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import SettingsIcon from '@mui/icons-material/Settings';
import { hasDebriefLicense } from 'ff/debrief/utils';
import SettingsPopover from 'ff/debrief/components/settings/SettingsPopover';

const SettingsButton = () => {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);

    const handleOpenPopover = () => setOpen(true);
    const handleClosePopover = () => setOpen(false);

    if (!hasDebriefLicense()) return null;

    return (
        <>
            <StyledButton onClick={handleOpenPopover} ref={buttonRef}>
                <SettingsIcon style={{ color: 'white' }} />
            </StyledButton>

            <SettingsPopover
                anchorEl={buttonRef.current}
                open={open}
                onClose={handleClosePopover}
            />
        </>
    );
};

const StyledButton = styled(Button)`
    background-color: #203040;
    padding: 8px 16px;
    border-radius: 4px;
`;

export default SettingsButton;
